export const articles = [
  {
    id: 1,
    title: "《怦然心动》— 纯真年代里最美好的初恋故事",
    slug: "flipped-review",
    category: "romance",
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20young%20couple%20sitting%20under%20a%20large%20sycamore%20tree%20at%20sunset%20golden%20hour%20warm%20light%20soft%20cinematic%20atmosphere%20dreamy%20aesthetic&width=800&height=450&seq=article-flipped&orientation=landscape",
    rating: 9.1,
    year: 2010,
    duration: "90分钟",
    summary: "一棵树，两个人，一份纯真年代的懵懂情感。这部电影用最细腻的笔触描绘了青春期的美好与成长，是夫妻情侣重温初恋感觉的最佳选择。",
    content: `<h2>故事简介</h2><p>朱莉·贝克虔诚地相信三件事：树是圣洁的、她在后院里饲养的鸡生出来的鸡蛋是最卫生的、以及总有一天她会和布莱斯·罗斯基接吻。二年级时在看到布莱斯的蓝眼睛那一瞬间，朱莉的心就被他击中了。不幸的是，布莱斯对她从来没有感觉。而且，他认为朱莉有点怪，怎么会有人把养鸡和坐在树下看成乐趣呢？</p><p>没想到，到了八年级，布莱斯开始觉得朱莉不同寻常的兴趣和对于家庭的自豪感使她显得很有魅力。而朱莉则开始觉得布莱斯漂亮的蓝眼睛也许和他本人一样其实很空洞。</p><h2>推荐理由</h2><p>《怦然心动》不仅是一部青春爱情片，更是一部关于成长、理解和自我认知的深刻作品。影片通过双视角叙事，让观众看到同一事件在两个人心中完全不同的解读，这种叙事手法极具启发性。</p><p>对于夫妻来说，这部电影提醒我们：爱情中最珍贵的是彼此理解与成长。朱莉和布莱斯的故事告诉我们，真正的爱不是一见钟情的冲动，而是在了解对方全部之后的坚定选择。</p><h2>适合场景</h2><p>周末午后，泡一壶茶，与爱人依偎在沙发上，让这部温暖的电影带你们回到那些心动的瞬间。</p>`,
    tags: ["初恋", "成长", "青春", "温暖"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-28",
    readTime: "8分钟",
  },
  {
    id: 2,
    title: "《爱在黎明破晓前》— 一夜之间，灵魂相遇的浪漫奇迹",
    slug: "before-sunrise-review",
    category: "romance",
    thumbnail: "https://readdy.ai/api/search-image?query=Couple%20walking%20through%20cobblestone%20streets%20of%20Vienna%20at%20night%20warm%20street%20lamps%20soft%20glow%20romantic%20European%20cityscape%20cinematic%20lighting%20intimate%20atmosphere&width=800&height=450&seq=article-sunrise&orientation=landscape",
    rating: 8.8,
    year: 1995,
    duration: "101分钟",
    summary: "一趟火车上的偶遇，一场维也纳的深夜漫步，两颗灵魂在一夜之间完成了最美的相遇。这是所有相信真爱的人都不该错过的经典。",
    content: `<h2>故事简介</h2><p>美国青年杰西在开往维也纳的火车上偶遇了法国女学生塞琳娜，两人一见如故，相谈甚欢。当火车到达维也纳时，杰西做出了一个大胆的决定：邀请塞琳娜和他一起下车，在维也纳共度一晚。</p><p>于是，两个陌生人在维也纳的街头漫步，从咖啡馆到游乐场，从教堂到河边，他们谈论着生活、爱情、死亡和梦想。一夜之间，他们仿佛认识了彼此一辈子。</p><h2>推荐理由</h2><p>《爱在黎明破晓前》是理查德·林克莱特"爱在"三部曲的开篇之作，被誉为影史上最浪漫的电影之一。整部电影几乎只有两个人的对话，却让人看得如痴如醉。</p><p>对于夫妻来说，这部电影最动人的地方在于它展现了两个人之间最纯粹的精神共鸣。杰西和塞琳娜的对话涵盖了人生的方方面面，他们的思想碰撞和心灵交流远比任何轰轰烈烈的爱情故事更加动人。</p><h2>适合场景</h2><p>纪念日或特殊夜晚，关掉手机，与爱人沉浸在维也纳的浪漫夜色中，聊聊你们的爱情故事。</p>`,
    tags: ["灵魂伴侣", "对话", "维也纳", "文艺"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-25",
    readTime: "10分钟",
  },
  {
    id: 3,
    title: "《初恋这件小事》— 暗恋是最美的青春告白",
    slug: "first-love-review",
    category: "comedy",
    thumbnail: "https://readdy.ai/api/search-image?query=Thai%20high%20school%20romantic%20comedy%20scene%20young%20girl%20transformation%20makeover%20school%20setting%20bright%20sunny%20day%20cheerful%20warm%20atmosphere%20nostalgic%20feel&width=800&height=450&seq=article-firstlove&orientation=landscape",
    rating: 8.5,
    year: 2010,
    duration: "118分钟",
    summary: "一个普通女孩为了暗恋的学长不断努力变好的故事，笑着笑着就哭了，看完只想抱紧身边的爱人。",
    content: `<h2>故事简介</h2><p>小水是一个平凡得不能再平凡的高中女生，成绩一般，长相一般。但在她遇到高年级学长阿亮的那一刻，一切都变了。为了能够配得上优秀的阿亮学长，小水开始了一场轰轰烈烈的自我改造计划。</p><p>她在好友们的帮助下，学习化妆、参加社团、提升成绩，一步步从丑小鸭蜕变成白天鹅。然而命运却跟她开了一个玩笑——当她终于鼓起勇气表白时，却发现一切和她想象的不太一样。</p><h2>推荐理由</h2><p>《初恋这件小事》是泰国青春爱情片的巅峰之作，它用幽默诙谐的方式讲述了一个关于暗恋、成长和友谊的故事。影片中那些傻傻的少女心事和对爱情的执着追求，让每个人都看到了自己青春的影子。</p><p>夫妻一起看这部电影，可以回忆起彼此年少时的心动时刻，那些青涩的暗恋、笨拙的表白，最终都成为了爱情中最珍贵的回忆。</p><h2>适合场景</h2><p>任何想轻松一笑的夜晚，这部影片能让你们笑中带泪，看完后忍不住聊聊彼此的初恋故事。</p>`,
    tags: ["暗恋", "青春", "泰国", "感人"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-22",
    readTime: "7分钟",
  },
  {
    id: 4,
    title: "《婚姻故事》— 关于爱与失去的深刻教科书",
    slug: "marriage-story-review",
    category: "drama",
    thumbnail: "https://readdy.ai/api/search-image?query=Couple%20having%20an%20intense%20emotional%20conversation%20in%20a%20minimalist%20living%20room%20warm%20evening%20light%20streaming%20through%20window%20cinematic%20dramatic%20scene%20with%20soft%20shadows&width=800&height=450&seq=article-marriage&orientation=landscape",
    rating: 8.6,
    year: 2019,
    duration: "136分钟",
    summary: "一部让所有已婚人士看完都会沉默的电影。它不美化爱情，不回避矛盾，却让我们在撕裂中更加懂得珍惜。",
    content: `<h2>故事简介</h2><p>查理是一位才华横溢的纽约戏剧导演，妮可是一位为家庭放弃事业的女演员。曾经相爱的两个人，在婚姻走到尽头时，不得不面对离婚过程中的种种痛苦。原本约定和平分开的他们，在律师的介入下，事情逐渐失控。</p><p>影片以极其真实的方式展现了婚姻破裂的全过程——从最初的协商到最终的对簿公堂，每一个细节都让人感同身受。</p><h2>推荐理由</h2><p>《婚姻故事》被誉为近年来最好的婚姻题材电影，亚当·德赖弗和斯嘉丽·约翰逊贡献了令人震撼的表演。影片中那段长达十分钟的争吵戏，堪称表演教科书。</p><p>推荐夫妻一起观看，不是因为它的结局美好，而是因为它让我们看到：即使是最相爱的两个人，如果不用心经营，也可能走向分离。这部电影是一面镜子，让我们审视自己的婚姻。</p><h2>适合场景</h2><p>准备好纸巾，找一个安静的夜晚。看完后，别忘了给爱人一个拥抱，告诉TA你有多珍惜。</p>`,
    tags: ["婚姻", "情感", "剧情", "深度"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-18",
    readTime: "12分钟",
  },
  {
    id: 5,
    title: "《时空恋旅人》— 每一天都是穿越时空的最好选择",
    slug: "about-time-review",
    category: "romance",
    thumbnail: "https://readdy.ai/api/search-image?query=British%20couple%20running%20hand%20in%20hand%20through%20rainy%20London%20street%20at%20night%20umbrella%20warm%20street%20lights%20romantic%20cinematic%20lighting%20cozy%20intimate%20atmosphere&width=800&height=450&seq=article-abouttime&orientation=landscape",
    rating: 8.8,
    year: 2013,
    duration: "123分钟",
    summary: "拥有穿越时空能力的男人，却用最普通的方式去爱一个人。这部电影告诉我们：幸福不在过去和未来，就在每一个平凡的今天。",
    content: `<h2>故事简介</h2><p>21岁的蒂姆·雷克被父亲告知了一个家族秘密：雷克家的男人都拥有穿越时空的能力。蒂姆决定用这个能力来寻找真爱。他遇到了玛丽，一个温柔可爱的美国女孩，两人坠入爱河。</p><p>然而蒂姆渐渐发现，即使能够穿越时空，生活依然充满了意外和无法挽回的遗憾。真正的智慧不是试图改变过去，而是珍惜当下的每一刻。</p><h2>推荐理由</h2><p>《时空恋旅人》不是一部普通的穿越电影，它用最温暖的方式探讨了人生的意义。影片后半段关于亲情的部分尤为动人，让人在欢笑中泪流满面。</p><p>对夫妻而言，这部电影是一剂温柔的提醒：不要因为日常的琐碎而忽略了爱。就像蒂姆最终领悟的那样——把每一天都当作第二次来过，用心感受那些被忽略的美好瞬间。</p><h2>适合场景</h2><p>平凡的日子里最不平凡的观影选择。看完后你们会不自觉地牵起手，感谢每一个能在一起的今天。</p>`,
    tags: ["穿越", "珍惜", "亲情", "温暖"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-15",
    readTime: "9分钟",
  },
  {
    id: 6,
    title: "《真爱至上》— 圣诞必看的十个爱情故事",
    slug: "love-actually-review",
    category: "classic",
    thumbnail: "https://readdy.ai/api/search-image?query=Christmas%20scene%20with%20multiple%20couples%20embracing%20in%20London%20Heathrow%20airport%20arrival%20gate%20warm%20festive%20decorations%20soft%20glowing%20lights%20heartwarming%20cinematic%20movie%20scene&width=800&height=450&seq=article-loveactually&orientation=landscape",
    rating: 8.5,
    year: 2003,
    duration: "135分钟",
    summary: "十个彼此交叉的爱情故事，在圣诞节前夕的伦敦交织成一幅关于爱的全景画卷。每年圣诞必刷的经典，每看一次都有新的感动。",
    content: `<h2>故事简介</h2><p>新晋首相爱上了为他端茶倒水的女秘书；过气摇滚歌手试图靠一首圣诞歌曲翻红；一个英国作家被女友背叛后在法国遇到了语言不通的葡萄牙女佣；一个小男孩为了心仪的女孩苦练架子鼓……</p><p>十个看似独立却又巧妙关联的爱情故事，在圣诞节前五周的时间里一一展开，最终汇聚成一个关于"爱真的无处不在"的温暖寓言。</p><h2>推荐理由</h2><p>《真爱至上》是圣诞电影的永恒经典，它用幽默、温暖和真诚打动了全世界观众。影片中那句"Love actually is all around"成为了无数人心中的信仰。</p><p>夫妻一起看这部电影，会在不同的人物身上看到自己的影子——初恋的心跳、婚姻的琐碎、失恋的痛苦、重逢的喜悦。影片传递的核心信息是：爱有很多种形式，但每一种都值得被珍惜。</p><h2>适合场景</h2><p>圣诞节或任何一个想感受温暖的夜晚。盖着毯子、捧着热可可，和爱人一起沉浸在这部冬日童话中。</p>`,
    tags: ["圣诞", "经典", "群像", "温暖"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-12",
    readTime: "11分钟",
  },
  {
    id: 7,
    title: "《你的名字》— 跨越时空的命运之恋",
    slug: "your-name-review",
    category: "latest",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20couple%20reaching%20out%20to%20each%20other%20on%20a%20hilltop%20at%20sunset%20beautiful%20starry%20sky%20comet%20falling%20twilight%20colors%20romantic%20dreamy%20atmosphere%20cinematic&width=800&height=450&seq=article-yourname&orientation=landscape",
    rating: 8.4,
    year: 2016,
    duration: "106分钟",
    summary: "新海诚的巅峰之作，两个素不相识的少年少女在梦中互换身体，一场穿越时空的爱恋就此展开。",
    content: `<h2>故事简介</h2><p>生活在东京的男高中生立花泷和生活在乡下小镇的女高中生宫水三叶，在某天醒来后惊讶地发现彼此交换了身体。两人开始通过手机留言来适应这种奇异的生活，渐渐地，一种特殊的情感在他们之间萌生。</p><p>然而某一天，泷发现身体交换突然停止了。他决定去寻找三叶，却发现了令人震惊的事实——三叶居住的小镇在三年前就被彗星碎片摧毁了。</p><h2>推荐理由</h2><p>《你的名字》是好莱坞之外全球票房最高的日本动画电影，新海诚用最精美的画面讲述了一个跨越时空的爱情故事。影片中的每一帧都可以截图当壁纸。</p><p>夫妻一起看这部电影，会被那种"即使忘记你的名字，我也记得我爱你"的执念所打动。影片最后在东京街头的相遇场景，让无数观众泪流满面。</p><h2>适合场景</h2><p>周末夜晚，关灯投影，享受这部视觉与情感双重盛宴的动画佳作。</p>`,
    tags: ["动画", "穿越", "新海诚", "唯美"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-08",
    readTime: "8分钟",
  },
  {
    id: 8,
    title: "《三傻大闹宝莱坞》— 笑着笑着就哭了的人生哲学课",
    slug: "three-idiots-review",
    category: "comedy",
    thumbnail: "https://readdy.ai/api/search-image?query=Three%20Indian%20college%20friends%20laughing%20together%20on%20campus%20sunny%20day%20colorful%20Indian%20architecture%20background%20joyful%20atmosphere%20warm%20cinematic%20lighting&width=800&height=450&seq=article-3idiots&orientation=landscape",
    rating: 9.2,
    year: 2009,
    duration: "170分钟",
    summary: "三个年轻人的大学故事，却讲透了人生、友情和爱情的全部道理。让你笑着开始，哭着结束，然后爱上生活。",
    content: `<h2>故事简介</h2><p>兰彻是帝国工程学院最与众不同的学生——他不死记硬背，不盲目服从，对知识充满真正的热爱。他的两个室友法尔罕和拉朱，在他的影响下，也开始重新审视自己的人生。</p><p>十年后，法尔罕和拉朱踏上了寻找兰彻的旅程，途中回忆起大学时光的点点滴滴，也揭开了兰彻身世的秘密。</p><h2>推荐理由</h2><p>《三傻大闹宝莱坞》是印度电影走向世界的里程碑之作。它用极其幽默的方式探讨了教育体制、家庭期望、人生价值等深刻话题。</p><p>对夫妻来说，这部电影的核心精神——"追求卓越，成功自然会来找你"——同样适用于婚姻。不要被社会的标准绑架，和爱人一起追求真正让你们快乐的生活。</p><h2>适合场景</h2><p>一个悠闲的周末下午，准备好零食，享受这三个多小时又哭又笑的奇妙旅程。</p>`,
    tags: ["友情", "人生", "印度", "喜剧"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-05",
    readTime: "10分钟",
  },
  {
    id: 9,
    title: "《触不可及》— 跨越阶级的灵魂友谊",
    slug: "intouchables-review",
    category: "drama",
    thumbnail: "https://readdy.ai/api/search-image?query=Two%20men%20in%20a%20luxury%20car%20driving%20through%20Paris%20at%20night%20one%20in%20wheelchair%20one%20laughing%20warm%20city%20lights%20cinematic%20mood%20emotional%20connection&width=800&height=450&seq=article-intouchables&orientation=landscape",
    rating: 9.3,
    year: 2011,
    duration: "112分钟",
    summary: "一个瘫痪的富翁和一个来自贫民区的护工，两个完全不搭边的人，却创造了世界上最温暖的友谊。",
    content: `<h2>故事简介</h2><p>菲利普是一位因滑翔伞事故而瘫痪的富豪，他在招聘护工时遇到了德瑞斯——一个刚刚出狱、只为拿到签字证明以领取失业救济金的黑人青年。在众多专业候选人中，菲利普偏偏选择了这个看起来最不靠谱的德瑞斯。</p><p>德瑞斯的随性、幽默和对菲利普毫无怜悯的态度，反而让菲利普感受到了久违的平等和快乐。两个来自不同世界的人，在相处中建立了一段跨越阶级的深厚友谊。</p><h2>推荐理由</h2><p>《触不可及》根据真实故事改编，是法国影史票房最高的电影之一。它没有刻意煽情，却让人在笑声中感受到最真挚的情感。</p><p>对于夫妻来说，这部电影传递了一个重要的信息：真正的亲密关系不在于表面的匹配，而在于内心的理解和尊重。菲利普和德瑞斯的友谊，就像最好的婚姻——相互成就，彼此照亮。</p><h2>适合场景</h2><p>想感受温暖和力量的夜晚。这部电影会让你们对生活充满感恩，对彼此更加珍惜。</p>`,
    tags: ["友谊", "真实故事", "法国", "感人"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-07-01",
    readTime: "9分钟",
  },
  {
    id: 10,
    title: "《泰坦尼克号》— 永不沉没的世纪之恋",
    slug: "titanic-review",
    category: "classic",
    thumbnail: "https://readdy.ai/api/search-image?query=Couple%20standing%20at%20the%20bow%20of%20a%20grand%20luxury%20ocean%20liner%20at%20sunset%20arms%20spread%20wide%20golden%20sky%20over%20ocean%20romantic%20epic%20cinematic%20scene&width=800&height=450&seq=article-titanic&orientation=landscape",
    rating: 9.4,
    year: 1997,
    duration: "194分钟",
    summary: "一段跨越阶级的旷世之恋，在人类历史上最著名的海难中绽放出最耀眼的光芒。二十多年过去，依然无人能够超越。",
    content: `<h2>故事简介</h2><p>1912年，穷画家杰克在泰坦尼克号首航的最后一刻赢到了船票。在船上，他偶遇了即将被迫嫁给富豪的贵族少女露丝。两人迅速坠入爱河，在船上度过了最美好的时光。</p><p>然而泰坦尼克号撞上冰山沉没，这段刚刚萌芽的爱情面临着生与死的考验。在冰冷的大西洋海水中，杰克将唯一的浮板留给了露丝，自己永远沉入了海底。</p><h2>推荐理由</h2><p>《泰坦尼克号》是一部现象级的电影，它重新定义了爱情片的格局。卡梅隆用最宏大的场面讲述了一个最私人的爱情故事，让全世界的观众为之动容。</p><p>夫妻重温这部经典，永远不会过时。因为真正的爱情，就像杰克对露丝说的那样——"赢得那张船票是我一生中最幸运的事。"珍惜眼前人，就是这部电影留给我们最珍贵的礼物。</p><h2>适合场景</h2><p>用一个完整的夜晚，重温这部近三个半小时的史诗爱情经典。建议准备好纸巾。</p>`,
    tags: ["经典", "史诗", "爱情", "催泪"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-06-28",
    readTime: "10分钟",
  },
  {
    id: 11,
    title: "《当幸福来敲门》— 在最艰难的时刻看见幸福",
    slug: "pursuit-of-happyness-review",
    category: "drama",
    thumbnail: "https://readdy.ai/api/search-image?query=Father%20and%20young%20son%20walking%20through%20San%20Francisco%20streets%20at%20sunset%20holding%20hands%20warm%20golden%20light%20city%20skyline%20background%20emotional%20cinematic%20scene&width=800&height=450&seq=article-pursuit&orientation=landscape",
    rating: 9.1,
    year: 2006,
    duration: "117分钟",
    summary: "真人真事改编，一个父亲带着儿子在绝境中不放弃希望的故事。威尔·史密斯父子同台飙戏，每次观看都是一次心灵的洗礼。",
    content: `<h2>故事简介</h2><p>克里斯·加德纳是一位普通的医疗器械推销员，他用全部积蓄投资了一种骨质密度扫描仪，却面临着卖不出去的困境。妻子离开了他，房东将他赶出家门，他不得不带着5岁的儿子流落街头。</p><p>然而克里斯没有放弃。他争取到了一个无薪实习的机会，在六个月的时间里，他白天拼命工作，晚上带着儿子辗转于收容所、地铁站厕所，却从未在儿子面前流露出一丝绝望。</p><h2>推荐理由</h2><p>《当幸福来敲门》是一部能给人无穷力量的电影。威尔·史密斯和亲生儿子贾登·史密斯的真实父子演绎，让影片的情感更加真挚动人。</p><p>夫妻一起看这部电影，会深刻体会到家庭的力量。无论生活多么艰难，只要两个人手牵手，就没有过不去的坎。影片结尾克里斯获得工作时在人群中无声哭泣的场景，是影史上最动人的瞬间之一。</p><h2>适合场景</h2><p>当生活遇到困难时，和爱人一起看这部电影。它会提醒你们：幸福不会主动来敲门，但你们可以一起去敲幸福的门。</p>`,
    tags: ["励志", "亲情", "真人真事", "奋斗"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-06-25",
    readTime: "9分钟",
  },
  {
    id: 12,
    title: "《疯狂动物城》— 和爱人一起笑出声的动画杰作",
    slug: "zootopia-review",
    category: "comedy",
    thumbnail: "https://readdy.ai/api/search-image?query=Bunny%20and%20fox%20characters%20in%20a%20vibrant%20colorful%20modern%20animal%20city%20with%20skyscrapers%20sunny%20day%20cheerful%20atmosphere%20digital%20animation%20style&width=800&height=450&seq=article-zootopia&orientation=landscape",
    rating: 9.2,
    year: 2016,
    duration: "109分钟",
    summary: "兔子警官和狐狸骗子的绝妙搭档，在一个充满想象力的动物城市里破案。老少皆宜的完美动画，笑着笑着就被治愈了。",
    content: `<h2>故事简介</h2><p>兔子朱迪从小梦想成为警察，尽管所有人都告诉她"兔子不可能当警察"，她还是凭借努力成为了动物城的第一位兔子警官。然而她却被分配去开罚单，满怀抱负无处施展。</p><p>为了证明自己，朱迪接下了一桩失踪案，被迫与狡猾的狐狸尼克合作。这对看似不搭的组合，在破案过程中逐渐建立了深厚的信任和友谊。</p><h2>推荐理由</h2><p>《疯狂动物城》是迪士尼近年来的巅峰之作，它不仅是一部欢乐的动画片，更是一部关于梦想、偏见和友情的深刻寓言。树懒"闪电"的桥段至今仍是影史上最搞笑的片段之一。</p><p>夫妻一起看这部电影，会被朱迪和尼克的化学反应逗得哈哈大笑，也会为影片中关于"任何人都可以成为任何想成为的人"的主题所感动。</p><h2>适合场景</h2><p>想轻松一下的任何时候。这部动画能让你们暂时忘掉烦恼，一起开怀大笑。</p>`,
    tags: ["动画", "迪士尼", "搞笑", "梦想"],
    author: "夫妻影院编辑团队",
    publishDate: "2026-06-20",
    readTime: "7分钟",
  },
];